export const getApiBaseUrl = (): string => {
  if (process.env.NODE_ENV === "development") {
    return "https://127.0.0.1:8000";
  }

  return "https://internal.api.replayglasses.com";
};
